export const TAB = {
  UPCOMING: 'upcoming',
  PAST: 'past',
  GALLERY: 'gallery',
  PURCHASED: 'purchased',
};

export const TABS_BY_ROLE = {
  artist: [TAB.UPCOMING, TAB.PAST, TAB.GALLERY],
  organizer: [TAB.UPCOMING, TAB.PAST, TAB.GALLERY],
  venue: [TAB.UPCOMING, TAB.PAST, TAB.GALLERY],
  buyer: [TAB.PURCHASED, TAB.PAST, TAB.GALLERY],
};
